import { render, staticRenderFns } from "./InfractionList.vue?vue&type=template&id=45ef1997&"
import script from "./InfractionList.vue?vue&type=script&lang=js&"
export * from "./InfractionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports